var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramThumbUp48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Small./ThumbUp48*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bounding-box",
    fillRule: "nonzero",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", {
    id: "ThumbUp",
    transform: "translate(7.000000, 5.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25,11.9027055 L9.25,26.9947709 C9.25,29.6950686 10.269213,31.1602582 12.0160271,31.8303829 C12.8683261,32.1573476 13.6546995,32.2431695 14.6963276,32.2375022 C14.758883,32.237149 14.758883,32.237149 14.8163215,32.2370237 C16.8894913,32.2370237 16.8894913,32.2370237 20.3034853,32.2370237 C21.9222412,32.2370237 21.9222412,32.2370237 23.3980658,32.2370237 C25.6342617,32.2370237 25.6342617,32.2370237 26.2341219,32.2370237 C27.3777375,32.2370237 28.5318306,31.403567 28.8544672,30.2126658 C29.0805587,29.3781271 29.3255513,28.4903321 29.6077005,27.4807313 C29.6934942,27.1737398 29.7828859,26.8548976 29.8787407,26.5138851 C32.5429586,17.0356789 32.9017467,15.6755506 32.9017467,14.5862154 C32.9017467,13.0545817 31.7681616,11.8699541 30.1131327,11.8699541 L19.9393322,11.8699541 L20.4211968,10.8096507 C21.4948324,8.44720411 21.9445275,6.71379217 21.9445275,4.87662404 C21.9445275,3.035998 20.9977258,1.77657422 19.5635248,1.46014473 C18.370361,1.19689557 17.4574092,1.87617513 16.7414847,3.57443713 C16.6409505,3.81291676 16.2386189,4.80054318 16.1441794,5.02731399 C15.8781702,5.66606275 15.6441808,6.19203194 15.393332,6.70128298 C13.8782931,9.77698067 11.9870452,11.6220461 9.25,11.9027055 Z",
    id: "Thumb-up",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.75,32.25 L9.25,32.25 L9.25,11.75 L0.75,11.75 L0.75,32.25 Z",
    id: "Sleeve",
    fill: "#FFCC00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramThumbUp48);
export default __webpack_public_path__ + "static/media/pictogramThumbUp48.6f478b12f0681103f28b22edd9850e2a.svg";
export { ForwardRef as ReactComponent };